import Box from "./Box";
import Button from "./Button";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function Checkbox({ active, label, onClick }) {
  return (
    <Button display="flex" alignItems="center" onClick={onClick}>
      <Box
        height={24}
        width={24}
        border="1px solid black"
        display="flex"
        justifyContent="center"
        alignItems="center"
        mr="9px"
      >
        <Box height={18} width={18} bg="black" opacity={active ? 1 : 0} />
      </Box>
      <Text fontSize={12} letterSpacing="1.7px" fontWeight={500} uppercase>
        {label}
      </Text>
    </Button>
  );
}

export default Checkbox;

Checkbox.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
